import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "../style/Login.css";
import { Modal } from "react-bootstrap";
import { apiFetchJson } from "../api";



const AddFeedback = ( { study, supervisor, traineeID, feedbackType, open, onClose }) => {

    const [data, setData] = useState({
        feedback: "",
        isSubmitting: false,
    });


    const handleChange = event => {
        setData({
            ...data,
            [event.target.name]: event.target.value,
        });
    };

    const handleCancel = event => {
        console.log('Cancel');
        onClose(false);
    }

    const handleFormSubmit = event => {
        event.preventDefault();
        setData({
            ...data,
            isSubmitting: true,
            errorMessage: null
        });
        apiFetchJson("api/feedback/"+supervisor.id+"/"+study.studyID+"/"+traineeID, {
            method: "post",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                feedbackText: data.feedback,
                feedbackType: feedbackType
            })
        }).then(data => {
            console.log('Return from feedback submission update,', data.message);
            setData({feedback:"", isSubmitting: false})
            onClose(false);
        })
        .catch(error => {
            console.log(error);
        })
    };


    return (
        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={open}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton={false}>
                <Modal.Title>{feedbackType} Feedback</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Control as="textarea" name='feedback' rows={3} onChange={handleChange} value={data.feedback || ''} />
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCancel}>
                    Cancel
                </Button>
                <Button variant="primary"  onClick={handleFormSubmit}>
                    Submit
                </Button>
            </Modal.Footer>

        </Modal>
    );
}

export default AddFeedback;
